<template>
  <card class="col-sm-12 col-lg-12 col-md-12" v-if="form">
    <div style="max-width: 500px;">
      <h2>Administrator Profile</h2>
      <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
        <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
          <base-input
            name="Name"
            mode="lazy"
            rules="required"
            label="Name"
            v-model="form.name"
          />

          <base-input
            name="E-Mail Address"
            mode="lazy"
            rules="required|email"
            label="E-Mail Address"
            v-model="form.email"
          />

          <m-select
            label="Default Company"
            v-model="form.defaultCompanyId"
            rules="required"
            :options="companies"
          ></m-select>

          <hr />
          <b-form-checkbox v-model="form.notifyUser" name="check-button">
            Send Reset Password Notification
          </b-form-checkbox>
          <b-form-checkbox v-model="form.isActive" name="check-button">
            Active
          </b-form-checkbox>

          <br />

          <b-button @click.prevent="cancel" variant="warning">Cancel</b-button>
          <b-button type="submit" variant="success">Save Profile</b-button>
        </b-form>
      </validation-observer>
    </div>
  </card>
</template>

<script>
import Role from "@/views/Components/User/Role.vue";

export default {
  components: { Role },
  data() {
    return {
      form: null,
      availableRoles: null,
      companies: [],
    };
  },
  methods: {
    cancel() {
      location.href = "/#/admin/adminusers";
    },
    rolesUpdated(roles) {
      this.form.roles = roles;
    },
    async onSubmit() {
      var self = this;
      let r = await self.$client.post("/api/user/upsertAdminUser", this.form);

      if (r.data.isSuccess) {
        self.$emitter.emit("success", { message: "Administrator Saved" });
        location.href = "/#/admin/adminusers";
      }
    },
  },
  async created() {
    var id = this.$route.params.id;

    let r = await this.$client.get(
      "/api/company/companies?isActive=true&rows=10000&page=1"
    );

    this.companies = r.data.value.map((e) => {
      return { value: e.id, text: e.companyName };
    });

    if (!id) {
      this.form = {
        notifyUser: true,
        isActive: true,
      };
    } else {
      let r = await this.$client.get("/api/user/adminUser?userId=" + id);
      this.form = r.data.value;
      this.availableRoles = r.data.value.availableRoles;
    }
  },
};
</script>

<style></style>
